<template>
  <template v-if="isLoading()">
    <Loading />
  </template>
  <template v-else>
     <div class="content p-number">
    <div class="container">
      <div class="row">
        <h3 class="mb-md-5">{{ content.name }}</h3>

        <div class="col-12" v-html="content.description"></div>
      </div>
    </div>
    </div>
  </template>
</template>

<script>
import Loading from "../layout/aniresan/Loading.vue";

export default {
  name: "page",
  components: {
    Loading,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      server: this.$store.state.server,
      content: {
        description: "",
      },
    };
  },

  props: {
    rootImagePath: {
      type: String,
    },
  },
  beforeMount() {
    this.initHome();
  },
  methods: {
    isLoading() {
      return this.server.pendingRequests.length > 0;
    },
    initHome() {
      this.$server({
        method: "post",
        url: "/api/General/GetContentUsingSlug",
        data: {
          Slug: this.$route.params.name,
        },
      })
        .then((response) => {
          response.data.content.description =
            response.data.content.description.replace(/\n/g, "<br>\n");
          this.initData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initData(obj) {
      this.content = obj.content;
    },
  },
};
</script>
<style scoped>
.content {
    margin-top:100px;
  width: 100%;
  min-height: 300px;
  text-align: justify;
}
.content .img {
  width: 100%;
  height: 300px;
}
</style>
